import { memo, useMemo } from "react";
import { makeIsUserRaisedHandByUserId } from "modules/broadcastRaiseHand/redux/selectors";
import { getFirstName } from "helpers/nameHelper";
import Avatar from "modules/userAvatar/Avatar";
import RaiseHandIcon from "modules/eventButtons/assets/RaiseHand.png";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { makeSelectUserById } from "modules/event/usersInEvent/selectors";
import { useSelector } from "react-redux";
import { getUserName } from "modules/userProfile";

interface IParticipantAvatarProps {
  userId: string;
}

const TRANSPARENT_COLOR = "rgba(0, 0, 0, 0)";

const ParticipantAvatar = memo(({ userId }: IParticipantAvatarProps) => {
  const user = useSelector(makeSelectUserById(userId));
  const isRaisedHand = useSelector(makeIsUserRaisedHandByUserId(userId));

  const firstName = useMemo(() => {
    if (user?.profile.firstName) {
      return user.profile.firstName;
    }

    if (user?.profile.name) {
      return getFirstName(user.profile.name);
    }

    return getUserName(user);
  }, [user]);

  return (
    <div className="audience-view-avatar-container">
      <div className="audience-view-avatar-image-container">
        <Avatar user={user} fallbackBackgroundColor={TRANSPARENT_COLOR} />
        <div
          data-testid={`audience-view-raised-hand-${userId}-${
            isRaisedHand ? "raised" : "not-raised"
          }`}
          className={`audience-view-raised-hand ${
            isRaisedHand ? "visible" : ""
          }`}
        >
          <img src={RaiseHandIcon} width={24} height={24} alt="" />
        </div>
      </div>
      {user && (
        <Typography
          component="div"
          color="inherit"
          className="audience-view-avatar-label"
        >
          {firstName}
        </Typography>
      )}
    </div>
  );
});

export default ParticipantAvatar;
